import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./scss/main.scss";

import * as serviceWorker from "./service-worker";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import translation_en from "./translations/EN/en.json";
import translation_sv from "./translations/SV/sv.json";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import storeConfig from "./redux/store";
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
// import CostCalculator from "./templates/CostCalculator";
import Routes from "./routes/Routes";
import configVars from "./config.js";
import { getWithExpiry, setWithExpiry } from "./common";
import { useCookies } from "react-cookie";
import fetch from 'cross-fetch';

const App = () => {
  const { store, persistor } = storeConfig;
  const [svStrings, setSvStrings] = useState({});
  const [enStrings, setEnStrings] = useState({});
  const [cookies, setCookie] = useCookies(["sc_user_lang"]);
  const [userLang, setUserLang] = useState('sv');

  useEffect(() => {

    const translatedStrings = getWithExpiry( 'translated_strings' );

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const chosenLang = urlParams.get("lang");
    let savedLang = cookies?.sc_user_lang;

    if ( ! savedLang ) {
      savedLang = 'sv';
    }

    if ( chosenLang && chosenLang.length > 0 ) {
      setCookie("sc_user_lang", chosenLang, { path: "/" });
    }

    if ( translatedStrings &&  ( savedLang === chosenLang || ( ! chosenLang && savedLang ) ) ) {
      setSvStrings( translatedStrings );
      setUserLang( savedLang );

    } else {

      let currrentLang = chosenLang;

      if ( ! currrentLang ) {
        currrentLang = 'sv';
      }

      setUserLang( currrentLang );

      (async () => {

        const fetchUrl = `${configVars.apiUrl}sustainchange/v1/gettranslatedstrings/?lang=${currrentLang}`;
    
        try{
    
          const response = await fetch(
            fetchUrl,
            {
            method: "GET",
              headers: {
                Authorization: `Basic ${configVars.auth}`,
              },
            }
          );
          
          const updateResponse = await response.json();
      
          if ( updateResponse ) {
    
            if ( updateResponse?.translations ) {

              if ( currrentLang === 'sv' ) {
                const mergedStrings = { ...translation_sv, ...updateResponse?.translations }
                setSvStrings( mergedStrings );
                setWithExpiry( 'translated_strings', mergedStrings );
              }

              if ( currrentLang === 'en' ) {
                const mergedStrings = { ...translation_en, ...updateResponse?.translations }
                setEnStrings( mergedStrings );
                setWithExpiry( 'translated_strings', mergedStrings );
              }
    
  
    
            }
    
          }
    
        } catch( error ) {
          console.log( error );
          return error;
        }
    
      })()

    }

  }, [cookies.sc_user_lang, setCookie]);

  i18next.init({
    interpolation: { escapeValue: false },
    lng: userLang,
    fallbackLng: "sv",
    resources: {
      en: {
        translations: enStrings,
      },
      sv: {
        translations: svStrings,
      },
    },
  });

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <I18nextProvider i18n={i18next}>
          <BrowserRouter
            getUserConfirmation={() => {
              /* Empty callback to block the default browser prompt */
            }}
          >
            <Routes />
          </BrowserRouter>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
};

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
serviceWorker.register();
